import { IntegrationEnum } from '@contracts/api/dto/providers/ProviderDto';
import { ColumnVisibilitySettings } from '@contracts/common/ColumnVisibilitySettings';
import { ColumnVisibilityType } from '@contracts/common/ColumnVisibilityType';
import {
  defaultColumnVisibilityOptions,
  defaultColumnVisibilityParams,
} from '@contracts/common/params/ColumnVisibilityParams';

export const providerListColumns = [
  'provider.id',
  'provider.updatedAt',
  'provider.name',
  'provider.apiUrl',
  'provider.syncRoundEnd',
  'provider.status',
  'provider.retryScheduledSendCredit',
  'provider.refundOnCreditFail',
  'provider.filterExternalProviderBets',
  'provider.isInternal',
  'provider.rgsId',
  'provider.integrationType',
  'provider.syncRaindrop',
  'provider.syncFreebet',
  'provider.notifyOnLastFreebet',
  'provider.enableInactivityScreen',
  'provider.raindropType',
  'provider.createdAt',
] as const;

export type ProviderListColumns = (typeof providerListColumns)[number];

export type ProviderListFilter = {
  'provider.id': string | undefined;
  'provider.updatedAt': string | undefined;
  'provider.name': string | undefined;
  'provider.apiUrl': string | undefined;
  'provider.syncRoundEnd': boolean | string | undefined;
  'provider.status': string | undefined;
  'provider.retryScheduledSendCredit': boolean | undefined;
  'provider.refundOnCreditFail': boolean | undefined;
  'provider.filterExternalProviderBets': boolean | undefined;
  'provider.isInternal': boolean | undefined;
  'provider.rgsId': string | undefined;
  'provider.integrationType': IntegrationEnum | undefined;
  'provider.syncRaindrop': boolean | undefined;
  'provider.syncFreebet': boolean | undefined;
  'provider.notifyOnLastFreebet': boolean | undefined;
  'provider.enableInactivityScreen': boolean | undefined;
  'provider.raindropType': string | undefined;
  'provider.createdAt': string | undefined;
};

export const defaultProviderListFilter: ProviderListFilter = {
  'provider.id': undefined,
  'provider.updatedAt': undefined,
  'provider.name': undefined,
  'provider.apiUrl': undefined,
  'provider.syncRoundEnd': undefined,
  'provider.status': undefined,
  'provider.retryScheduledSendCredit': undefined,
  'provider.refundOnCreditFail': undefined,
  'provider.filterExternalProviderBets': undefined,
  'provider.isInternal': undefined,
  'provider.rgsId': undefined,
  'provider.integrationType': undefined,
  'provider.syncRaindrop': undefined,
  'provider.syncFreebet': undefined,
  'provider.notifyOnLastFreebet': undefined,
  'provider.enableInactivityScreen': undefined,
  'provider.raindropType': undefined,
  'provider.createdAt': undefined,
};

export const providerListColumnVisibilitySettings = {
  'provider.id': ColumnVisibilityType.Visible,
  'provider.name': ColumnVisibilityType.CanBeHidden,
  'provider.status': ColumnVisibilityType.CanBeHidden,
  'provider.isInternal': ColumnVisibilityType.CanBeHidden,
  'provider.syncRoundEnd': ColumnVisibilityType.CanBeHidden,
  'provider.retryScheduledSendCredit': ColumnVisibilityType.CanBeHidden,
  'provider.refundOnCreditFail': ColumnVisibilityType.CanBeHidden,
  'provider.filterExternalProviderBets': ColumnVisibilityType.CanBeHidden,
  'provider.syncRaindrop': ColumnVisibilityType.CanBeHidden,
  'provider.syncFreebet': ColumnVisibilityType.CanBeHidden,
  'provider.notifyOnLastFreebet': ColumnVisibilityType.CanBeHidden,
  'provider.enableInactivityScreen': ColumnVisibilityType.CanBeHidden,
  'provider.raindropType': ColumnVisibilityType.CanBeHidden,
  'provider.createdAt': ColumnVisibilityType.CanBeHidden,
  'provider.rgsId': ColumnVisibilityType.CanBeVisible,
  'provider.apiUrl': ColumnVisibilityType.CanBeVisible,
  'provider.integrationType': ColumnVisibilityType.CanBeVisible,
  'provider.updatedAt': ColumnVisibilityType.CanBeVisible,
} satisfies ColumnVisibilitySettings<ProviderListColumns>;

export const defaultProviderListColumnVisibility = defaultColumnVisibilityParams(
  providerListColumnVisibilitySettings
);

export const providerListColumnVisibilityOptions = defaultColumnVisibilityOptions(
  providerListColumns,
  providerListColumnVisibilitySettings
);
